
import {
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
} from '../../../Constants/actionTypes';


import { API_GET_ALL_TENENT_BOOKINGS } from '../../../Constants/apiUrls'
import { fetchAllTenantBooking } from '../../../Constants/apiService'




export const fetchBookingsRequest = () => ({
  type: FETCH_BOOKINGS_REQUEST,
});

export const fetchBookingsSuccess = (bookings) => ({
  type: FETCH_BOOKINGS_SUCCESS,
  payload: bookings,
});

export const fetchBookingsFailure = (error) => ({
  type: FETCH_BOOKINGS_FAILURE,
  payload: error,
});


export const fetchBookings = () => {
  return async (dispatch, getState) => {
    dispatch(fetchBookingsRequest());

    try {
      // Retrieve access token from the state
      const state = getState();
      const accessToken = state.auth.accessToken; 
      const data = await fetchAllTenantBooking(accessToken);
      dispatch(fetchBookingsSuccess(data));
    } catch (error) {
      let errorMessage;
      if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
        errorMessage = 'Server is currently down. Please try again later.';
      } else {
        errorMessage = error.message;
      }
      dispatch(fetchBookingsFailure(errorMessage));
    }
  };
};
